if (!customElements.get('anchor-content')) {
  class AnchorContent extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }

    /**
     * Scrolls to the anchor target, compensating for a sticky header.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      const link = evt.target.closest('a[href^="#"]');
      if (!link) return;

      const target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;

      evt.preventDefault();

      let headerHeight = 0;
      if (document.querySelector('store-header[data-is-sticky="true"]')) {
        headerHeight = Number.parseInt(
          getComputedStyle(this.parentElement).getPropertyValue('--header-height').replace('px', ''),
          10
        ) || 0;
      }

      window.scrollTo({
        top: target.getBoundingClientRect().top + window.scrollY - headerHeight - 20,
        behavior: 'smooth'
      });
    }
  }

  customElements.define('anchor-content', AnchorContent);
}
